import { Routes } from '@angular/router';

import {AdmisComponent} from './admis.component';


export const admisRoute: Routes = [
  {
    path: 'admis',
    component: AdmisComponent,
    data: {
        pageTitle: 'cadensApp.admis.home.title'
    }
  }
];




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/admis/admis.route.ts